import Head from "next/head"
import { GetStaticPropsResult } from "next"
import Image from "next/image"
import Link from "next/link"
import classNames from "classnames"
import { DrupalFile, DrupalMedia, DrupalNode, JsonApiErrors } from "next-drupal"
import { drupal } from "lib/drupal"

import { getGlobalElements } from "lib/get-global-elements"
import { Meta, MetaProps } from "components/meta"
import { useTranslation } from "next-i18next"
import { absoluteURL, formatDate } from "lib/utils"
import cn from 'classnames'

import { Layout, LayoutProps } from "components/layout"
import { NodeArticleTeaser } from "components/node--article--teaser"
import siteConfig from "site.config"

interface IndexPageProps {
  nodes: DrupalNode[]
}



export default function IndexPage({ nodes, menus, blocks, }: IndexPageProps) {
  const { t } = useTranslation()

  return (
    <Layout meta={{ title: t("Comité d'histoire de la politique de la ville") }} menus={menus} blocks={blocks}>



      <div className="max-w-screen-2xl mx-auto container orange-500">

      <div className="max-w-screen-xl mx-auto container py-20 ">

      <div className="inline-block w-100 pb-10 text-white titre text-5xl font-semibold text-center">BIBLIOGRAPHIE</div>

<div className="grid grid-cols-1 md:grid-cols-2 gap-4 xs:grid-cols-1">
{nodes?.length ? (
  nodes.map((node) => (
    <div key={node.id}
    className=" space-x-3  border border-gray-300 bg-white px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400"
>
    <div className="grid grid-cols-12  gap-4">




<div className="col-span-12 text-center  sm:col-span-5">

{node.field_media_image && (
  <figure>
 


      <Image
  src=  {absoluteURL(node.field_media_image.field_media_image.uri.url)}
  alt={node.title || "Image"}
  title={node.title}
  priority={true}
  width={215}
      height={330}
style={{
    objectFit: "contain", // Maintient les proportions
    height: "330px",      // Contraint la hauteur
    width: "auto",        // Ajuste automatiquement la largeur en fonction de la hauteur
    maxHeight: "330px",   // Limite la hauteur maximale
        margin: "0 auto",     // Ajoute mx-auto pour centrer l'image horizontalement

  }}  // Maintient les proportions
/>
  </figure>
)}
</div>
<div className="col-span-12  sm:col-span-7">
<Link

  href={node.path.alias}
  passHref
  className={classNames(
    "text-2xl font-medium hover:text-gray-900 w-100",

  )}
  >

  <div className="titre text-3xl  mb-4 text-gray-600 hover:text-gray-900 w-100">{node.title}</div>

</Link>
<Link  href={node.path.alias} passHref >

  <div className="prose-md  mx-auto mb-4 text-gray-600">{node.body.summary}</div>

</Link>
</div>
    </div>
        </div>
  ))
) : (
  <span className="py-4"></span>
)}


</div>


</div>





      </div>

    </Layout>
  );
}

export async function getStaticProps(
  context
): Promise<GetStaticPropsResult<IndexPageProps>> {
  const nodes = await drupal.getResourceCollectionFromContext<DrupalNode[]>(
    "node--article",
    context,
    {
      params: {
        "filter[promote]": 1,
        "filter[status]": 1,

 filter: {
    type: { group: { conjunction: "OR" } },
    type_rent: { condition: { path: "field_categorie.id", value: "49efc8d7-2996-4289-8a82-d8be54279996", memberOf: "type" } },
    type_sell: { condition: { path: "field_categorie.id", value: "cc3b91b9-aef5-4dc9-910a-f36227e0dd91", memberOf: "type" } },
  },
        include: "field_media_image.field_media_image,uid",
        sort: "-created",
      },
    }
  )

  return {
    props: {
      ...(await getGlobalElements(context)),

      nodes,
    },
           revalidate: 5, // In seco
  }
}
